import api from "./api";
import endpoints from "./endpoints";

export default {
  getAiTextGenerationStyles: async function (language: string) {
    const response = await api.get(endpoints.aiTexter.getStyles, { params: { languageCode: language } });
    return response.data;
  },
  generateText: async function (language: string, args: any, style: string, signal: AbortSignal) {
    const response = await api.post(endpoints.aiTexter.generateText, args, { params: { languageCode: language, style: style }, signal: signal });
    return response.data;
  }
};
